import { render, staticRenderFns } from "./CurationVuexListComponent.vue?vue&type=template&id=7ddcd51a&scoped=true&"
import script from "./CurationVuexListComponent.vue?vue&type=script&lang=js&"
export * from "./CurationVuexListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddcd51a",
  null
  
)

export default component.exports